import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { listVideos, listChannels, resolveFileUrl } from '../lib/api';
import VideoCard from '../components/VideoCard';
import { CATEGORIES } from '../mock';
import { Search as SearchIcon, Loader2 } from 'lucide-react';

export default function Search() {
  const [sp, setSp] = useSearchParams();
  const q0 = sp.get('q') || '';
  const [q, setQ] = useState(q0);
  const [cat, setCat] = useState('all');
  const [results, setResults] = useState([]);
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const params = { limit: 100 };
        if (q0) params.q = q0;
        if (cat !== 'all') params.category = cat;
        const [vids, chs] = await Promise.all([ listVideos(params), q0 ? listChannels() : Promise.resolve([]) ]);
        setResults(vids);
        if (q0) {
          const t = q0.toLowerCase();
          setChannels(chs.filter(c => c.name.toLowerCase().includes(t) || (c.handle || '').toLowerCase().includes(t)));
        } else { setChannels([]); }
      } finally { setLoading(false); }
    })();
  }, [q0, cat]);

  const submit = (e) => { e.preventDefault(); setSp({ q }); };

  return (
    <div>
      <form onSubmit={submit} className="flex items-center gap-2 max-w-xl">
        <div className="flex-1 flex items-center gap-2 bg-white/[0.04] border border-white/10 rounded-full px-4 focus-within:border-[#ff2e63]/60">
          <SearchIcon className="w-4 h-4 text-white/50" />
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search VidCreForge…" className="flex-1 bg-transparent py-2.5 focus:outline-none text-[14px] placeholder:text-white/40" />
        </div>
        <button className="btn-primary">Search</button>
      </form>

      <div className="mt-4 flex items-center gap-2 flex-wrap">
        <button onClick={() => setCat('all')} className={`chip ${cat === 'all' ? 'active' : ''}`}>All</button>
        {CATEGORIES.map(c => (
          <button key={c.slug} onClick={() => setCat(c.slug)} className={`chip ${cat === c.slug ? 'active' : ''}`}>{c.name}</button>
        ))}
      </div>

      {channels.length > 0 && (
        <div className="mt-8">
          <h2 className="row-title text-white mb-4">Channels</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {channels.map(c => (
              <a key={c.id} href={`/channel/${c.id}`} className="card-shell p-4 flex items-center gap-3 hover-lift">
                <img src={resolveFileUrl(c.avatar)} alt={c.name} className="w-14 h-14 rounded-full object-cover" />
                <div><div className="font-semibold">{c.name}</div><div className="text-[12.5px] text-white/55">{c.handle}</div></div>
              </a>
            ))}
          </div>
        </div>
      )}

      <div className="mt-8">
        <h2 className="row-title text-white mb-4">{q0 ? `Results for "${q0}"` : 'All videos'} ({results.length})</h2>
        {loading ? (
          <div className="flex items-center gap-2 text-white/60"><Loader2 className="w-5 h-5 animate-spin" /> Loading…</div>
        ) : results.length === 0 ? (
          <div className="text-white/55">No matches. Try different keywords.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {results.map(v => <VideoCard key={v.id} video={v} />)}
          </div>
        )}
      </div>
    </div>
  );
}
